// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
    height: 35px;
  }
.mat-toolbar-row, .mat-toolbar-single-row {
    height: 50px;
    z-index: 2004;
  }
  .mat-toolbar-multiple-rows {
    min-height: 50px;
    border-bottom: 1px #eee solid;
  }
#map{
    height : calc(100vh - 51px);
}
.tool-btn {
    left: 15px;
    top: 70px;
    position: absolute;
    z-index: 1000;
    letter-spacing: 1px;
}
.tool-btn .mat-icon {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/shared-admin-layer/shared-admin-layer.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;AACF;IACI,YAAY;IACZ,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;AACF;IACI,2BAA2B;AAC/B;AACA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,eAAe;AACjB","sourcesContent":[".logo {\n    height: 35px;\n  }\n.mat-toolbar-row, .mat-toolbar-single-row {\n    height: 50px;\n    z-index: 2004;\n  }\n  .mat-toolbar-multiple-rows {\n    min-height: 50px;\n    border-bottom: 1px #eee solid;\n  }\n#map{\n    height : calc(100vh - 51px);\n}\n.tool-btn {\n    left: 15px;\n    top: 70px;\n    position: absolute;\n    z-index: 1000;\n    letter-spacing: 1px;\n}\n.tool-btn .mat-icon {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
